import React, { useRef, useState } from 'react';
import './NavRight.scss';
import { createPopper } from '@popperjs/core';
import reset from '../../assets/reset.svg';
import compare from '../../assets/compare.svg';
import compareCircle from '../../assets/compare_circle.svg';
import howTo from '../../assets/how-to-use.svg';
import NavRightTooltip from './NavRightTooltip';

function ResetCompare({
  savedDataArray,
  setShowCompare,
  setShowAreaDetail,
  handleReset,
  showHamburger,
  handleClickHamburger,
  setCurrentState,
  handleClickI,
  handleClickNavButtons,
  buttonActive
}) {
  const [currentNav, setCurrentNav] = useState();
  const navTooltip = useRef();

  const createNavToolTip = (e) => {
    const content = navTooltip.current;
    createPopper(e.target, content, {
      placement: 'bottom'
    });
    content.style.visibility = 'visible';
  };

  const handleMouseEnterNavButtons = (e) => {
    createNavToolTip(e);
    const name = e.target.getAttribute('data-name');
    setCurrentNav(name);
  };

  const handleMouseLeaveNavButtons = (e) => {
    navTooltip.current.style.visibility = 'hidden';
  };

  return (
    <div className="resetCompare">
      <NavRightTooltip currentNav={currentNav} navTooltip={navTooltip} />
      <div className="navRight__compare">
        {savedDataArray && savedDataArray.length > 0 ? (
          <div className="compare__circle">
            <img className="compare__circle__circle" src={compareCircle} alt="" />
            <p className="compare__circle__number">{savedDataArray.length}</p>
          </div>
        ) : (
          <></>
        )}

        <img
          id="compare"
          className="navRight__icon compare__icon"
          src={compare}
          alt="Click to see all saved areas"
          data-name="Compare"
          onClick={
            showHamburger
              ? () => {
                  handleClickHamburger('close');
                  setShowCompare(true);
                  setShowAreaDetail(false);
                }
              : () => {
                  setShowCompare(true);
                  setShowAreaDetail(false);
                }
          }
          onMouseEnter={handleMouseEnterNavButtons}
          onMouseLeave={handleMouseLeaveNavButtons}
        />
      </div>

      <img
        className="navRight__icon reset"
        src={reset}
        alt="Click to reset the map"
        data-name="Reset"
        onClick={
          showHamburger
            ? () => {
                handleClickHamburger('close');
                setShowAreaDetail(false);
                setCurrentState(null);
                setShowCompare(false);
                handleClickNavButtons(buttonActive);
              }
            : handleReset
        }
        onMouseEnter={handleMouseEnterNavButtons}
        onMouseLeave={handleMouseLeaveNavButtons}
      />
      <img
        className="navRight__icon howToIcon desktop-only"
        src={howTo}
        alt="Click to see How to use the map"
        data-name="How To"
        onClick={handleClickI}
        onMouseEnter={handleMouseEnterNavButtons}
        onMouseLeave={handleMouseLeaveNavButtons}
      />
    </div>
  );
}

export default ResetCompare;
